import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { Link } from 'react-router-dom';
import Themes from '../../styling/themes';

const BaseButtonStyle = () => css`
  border: 1px solid;
  display: inline-block;
  font-size: ${fontSize};
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  padding: ${padding};
  text-align: center;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};

  :disabled {
    opacity: 0.6;
  }

  :not(:disabled) {
    cursor: pointer;
  }

  :hover:not(:disabled) {
    opacity: 0.8;
  }

  svg {
    margin-right: 0.5rem;
  }
`;

const backgroundColor = theme.variants('mode', 'kind', {
  default: {
    light: Themes.light.defaultBackgroundColor,
    dark: Themes.dark.defaultBackgroundColor,
    custom: Themes.custom.defaultBackgroundColor
  },
  primary: {
    light: Themes.light.primaryBackgroundColor,
    dark: Themes.dark.primaryBackgroundColor,
    custom: Themes.custom.primaryBackgroundColor
  },
  secondary: {
    light: Themes.light.secondaryBackgroundColor,
    dark: Themes.dark.secondaryBackgroundColor,
    custom: Themes.custom.secondaryBackgroundColor
  },
  warning: {
    light: Themes.light.warningBackgroundColor,
    dark: Themes.dark.warningBackgroundColor,
    custom: Themes.custom.warningBackgroundColor
  },
  success: {
    light: Themes.light.successBackgroundColor,
    dark: Themes.dark.successBackgroundColor,
    custom: Themes.custom.successBackgroundColor
  },
  info: {
    light: Themes.light.infoBackgroundColor,
    dark: Themes.dark.infoBackgroundColor,
    custom: Themes.custom.infoBackgroundColor
  },
  danger: {
    light: Themes.light.dangerBackgroundColor,
    dark: Themes.dark.dangerBackgroundColor,
    custom: Themes.custom.dangerBackgroundColor
  }
});

const borderColor = theme.variants('mode', 'kind', {
  default: {
    light: Themes.light.defaultBorderColor,
    dark: Themes.dark.defaultBorderColor,
    custom: Themes.custom.defaultBorderColor
  },
  primary: {
    light: Themes.light.primaryBorderColor,
    dark: Themes.dark.primaryBorderColor,
    custom: Themes.custom.primaryBorderColor
  },
  secondary: {
    light: Themes.light.secondaryBorderColor,
    dark: Themes.dark.secondaryBorderColor,
    custom: Themes.custom.secondaryBorderColor
  },
  warning: {
    light: Themes.light.warningBorderColor,
    dark: Themes.dark.warningBorderColor,
    custom: Themes.custom.warningBorderColor
  },
  success: {
    light: Themes.light.successBorderColor,
    dark: Themes.dark.successBorderColor,
    custom: Themes.custom.successBorderColor
  },
  info: {
    light: Themes.light.infoBorderColor,
    dark: Themes.dark.infoBorderColor,
    custom: Themes.custom.infoBorderColor
  },
  danger: {
    light: Themes.light.dangerBorderColor,
    dark: Themes.dark.dangerBorderColor,
    custom: Themes.custom.dangerBorderColor
  }
});

const color = theme.variants('mode', 'kind', {
  default: { light: Themes.light.defaultColor, dark: Themes.dark.defaultColor, custom: Themes.custom.defaultColor },
  primary: { light: Themes.light.primaryColor, dark: Themes.dark.primaryColor, custom: Themes.custom.primaryColor  },
  secondary: {
    light: Themes.light.secondaryColor,
    dark: Themes.dark.secondaryColor,
    custom: Themes.custom.secondaryColor
  },
  warning: { light: Themes.light.warningColor, dark: Themes.dark.warningColor, custom: Themes.custom.warningColor },
  success: { light: Themes.light.successColor, dark: Themes.dark.successColor, custom: Themes.custom.successColor },
  info: { light: Themes.light.infoColor, dark: Themes.dark.infoColor, custom: Themes.custom.infoColor },
  danger: { light: Themes.light.dangerColor, dark: Themes.dark.dangerColor, custom: Themes.custom.dangerColor }
});

const fontSize = theme.variants('mode', 'size', {
  default: { light: '1rem', dark: '1rem', custom: '1rem' },
  small: { light: '0.875rem', dark: '0.875rem', custom: '0.875rem' }
});

const padding = theme.variants('mode', 'size', {
  default: {
    light: '0.375rem 0.75rem',
    dark: '0.375rem 0.75rem',
    custom: '0.375rem 0.75rem'
  },
  small: { light: '0 0.25rem', dark: '0 0.25rem', custom: '0 0.25rem' }
});

export const Button = styled.button`
  ${BaseButtonStyle()};
  background-color: ${backgroundColor};
  border-color: ${borderColor};
  color: ${color};
`;

Button.defaultProps = {
  kind: 'default',
  fullWidth: false,
  size: 'default'
};

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  color: #717171;
  outline: none;
`;

export const LinkButton = styled(Link)`
  ${BaseButtonStyle()};
  background-color: ${backgroundColor};
  border-color: ${borderColor};
  color: ${color};
  text-decoration: none;
`;

LinkButton.defaultProps = {
  kind: 'default',
  size: 'default'
};
